import React, { useContext, useState, useEffect } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import Title from "./Title"
import Lamp from "./Lamp"
import ImageList from "./ImageList"
import Information from "./Information"
import Leaflets from "./Leaflets"
import Feedback from "../Common/Feedback"
import Icon from "../Utils/Icon"
import * as styles from "../Common/Styles/DetailContainer.module.scss"
import classNames from "classnames/bind"
import { RequestHandler } from "../Utils/request_handler"
const cn = classNames.bind(styles)
import Sentry from "../Common/Sentry"
import tokubaiLogo from "../../images/tokubai.png"

const fetchLeaflets = async () => {
  try {
    const path = `${location.href}/leaflets`
    const handler = new RequestHandler(path, "GET")
    const res = await handler.requestWithBody()
    if (res.status == 200) {
      return res.body
    }
    return []
  } catch (e) {
    Sentry.captureException(e)
    return []
  }
}

const Container = (props) => {
  const url = props.place.url
  const urlTitle = "外部サイトで詳しく見る"
  const isPC = useContext(PCViewContext)
  const [leaflets, setLeaflets] = useState([])

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        const list = await fetchLeaflets()
        setLeaflets(list)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className={cn("container", isPC ? "pc" : "sp")}>
      {props.place.image && (
        <div className={styles.image}>
          <img src={props.place.image.url} />
        </div>
      )}
      <div className={styles.contents}>
        <Title place={props.place} />
        {url && (
          <a className={styles.urlButton} href={url} target="_blank">
            <div>
              <span>{urlTitle}</span>
              <Icon
                className={styles.urlIcon}
                type="feather"
                name="external-link"
                attr={{ height: 20, width: 20 }}
              />
            </div>
          </a>
        )}
        <hr className={styles.hr} />
        <Lamp {...props} />
        <hr className={styles.hr} />
        {props.place.images && props.place.images.length > 0 && (
          <React.Fragment>
            <h2 className={styles.header}>このお店・施設の写真</h2>
            <ImageList images={props.place.images} />
          </React.Fragment>
        )}
        {props.place.images && props.place.images.length > 0 && (
          <hr className={styles.hr} />
        )}
        {props.leafletsAvailable && leaflets.length > 0 && (
          <React.Fragment>
            <h2 className={styles.header}>
              掲載中のチラシ
              <img src={tokubaiLogo} />
            </h2>
            <Leaflets leaflets={leaflets} />
            <hr className={styles.hr} />
          </React.Fragment>
        )}
        <Information place={props.place} />
        <Feedback />
      </div>
    </div>
  )
}

export default Container
